const isHeavyVehicle = weight => parseInt(weight, 10) > 3500;
export default isHeavyVehicle;